import { Component, ReactNode } from "react"

import moment from "moment"

import { NUMBER_PATTERN } from '../../libs/validation/stringRegex'
import { numberValidation } from '../../libs/validation/remoteValidationAbstract'
import { DATE_FORMAT, DATE_PRINT_FORMAT, isNotValidInizioPolizza } from "../../libs/validation/dateValidation"

import Input from '../../libs/ui/inputs/Input'

interface ValueAndDateInterface {
    valore: number | undefined
    data: string | undefined

    showDate: boolean

    valoreId: string
    dataId: string

    valoreLabel : string | undefined
    dataLabel: string | undefined

    valoreError: string | undefined
    dataError: string | undefined

    updateValoreCallBack: Function
    updateDataCallBack: Function
}

class ValueAndDate extends Component<ValueAndDateInterface> {

    constructor (props: any) {
        super (props)

        this.isValidDate = this.isValidDate.bind(this)
    }

    render (): ReactNode {
        const NOW = new Date()

        const DATE_START = moment(NOW).format(DATE_FORMAT)
        const DATE_END = moment(NOW).add(1, 'year').format(DATE_FORMAT)

        const DATE_START_FORMATTED = moment(NOW).format(DATE_PRINT_FORMAT)
        const DATE_END_FORMATTED = moment(NOW).add(1, 'year').format(DATE_PRINT_FORMAT)

        const containerClass = this.props.showDate ? 'col-12 col-md-6' : 'col-12'

        return (
            <div className="col-12">
                <div className="row">
                    <div className={containerClass}>
                        <Input 
                            id={this.props.valoreId} name={this.props.valoreId} key={this.props.valoreId}
                            label={this.props.valoreLabel ?? 'Valore di perizia dell’immobile'}
                            value={this.props.valore?.toString()}
                            type='number'
                            step='1'
                            min='1'
                            regexp={NUMBER_PATTERN}
                            remoteValidation={numberValidation}
                            errorDisplayMsg={'Valore non valido'}
                            callback={this.props.updateValoreCallBack}
                            error={this.props.valoreError}
                        />
                    </div>
                    { this.props.showDate === true &&
                        <div className="col-12 col-md-6">
                            <Input 
                                id={this.props.dataId} name={this.props.dataId} key={this.props.dataId}
                                label={this.props.dataLabel ?? 'Data presunta di rogito o surroga'}
                                type='date'
                                value={this.props.data}
                                min={DATE_START}
                                max={DATE_END}
                                callback={this.props.updateDataCallBack}
                                errorDisplayMsg={
                                    'tra ' + 
                                    DATE_START_FORMATTED + 
                                    ' e ' + DATE_END_FORMATTED
                                }
                                regexp={this.isValidDate}
                                error={this.props.dataError}
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }

    private isValidDate (date: string | undefined) {
        if ( this.props.showDate === true && date !== undefined) {
            return !isNotValidInizioPolizza( date )
        }

        return true
    }

}

export default ValueAndDate